import { Features, STYLOVYZE_FLAGS, ThemeVariables } from '../types/features';
import { useSelectFeatures } from '../selectors';
import { INFO360_THEMES } from '../hocs/ApplicationWrapper/theme/theme.types';
import { useMemo } from 'react';

// Keep the features returned properly typed
export function useIsFeatureEnabled<K extends keyof Features>(
	feature: K,
): Features[K] {
	const features: Features = useSelectFeatures();
	return features[feature];
}

export function useIsDebugModeEnabled(): boolean {
	return !!useIsFeatureEnabled(STYLOVYZE_FLAGS.DEBUG_MODE);
}

// legacy exports (incorrect hook shape)
export function isFeatureEnabled<K extends keyof Features>(feature: K) {
	console.warn(
		'Warning - the function isFeatureEnabled() is deprecated. Switch to use useIsFeatureEnabled instead',
	);
	// eslint-disable-next-line
	return useIsFeatureEnabled(feature);
}

export function useThemeVariables(): ThemeVariables {
	const themeVariables = useIsFeatureEnabled(
		STYLOVYZE_FLAGS.THEME_VARIABLES,
	) as unknown as ThemeVariables | null;

	const displayThemePicker = themeVariables?.displayThemePicker ?? false;
	const darkButtonEnabled = themeVariables?.darkButtonEnabled ?? false;

	let defaultTheme =
		INFO360_THEMES[
			(themeVariables?.defaultTheme as keyof typeof INFO360_THEMES) ??
				'innovyze'
		] ?? INFO360_THEMES.Classic;
	if (displayThemePicker && defaultTheme === INFO360_THEMES.Classic) {
		defaultTheme = INFO360_THEMES.Light;
	}

	const memoed = useMemo(
		() => ({ defaultTheme, displayThemePicker, darkButtonEnabled }),
		[defaultTheme, displayThemePicker, darkButtonEnabled],
	);

	return memoed;
}
